import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TryOnWidgetConfigurationPageSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="80%" height={20} />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.ColorsGrid>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.ColorsGrid>
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Skeleton variant="rounded" width="100%" height={240} />
      <Skeleton variant="rounded" width="100%" height={120} />
    </Styles.Container>
  )
}

export default TryOnWidgetConfigurationPageSkeleton
